// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const SearchByDropDown = t.struct({
    searchBy: t.list(KeyValuePair, 'searchBy'),
    selectedOption: KeyValuePair
}, 'SearchByDropDown');

export const getDefaultState = () =>
    new SearchByDropDown({
        searchBy: [
            {
                key: 'PIN',
                value: 'PIN'
            },
            {
                key: 'PIP',
                value: 'PIP'
            }
        ],
        selectedOption: {
            key: 'PIN',
            value: 'PIN'
        }
    });

export default SearchByDropDown;



// WEBPACK FOOTER //
// ./src/pip/shared/state/search-by-dropdown.js